import { ExtensionContainer, ExtensionStage } from 'tessa/extensions';
import { CdSignFileContextMenuFileExtension } from './CdSignFileContextMenuFileExtension';
import { CdGetFileForPrintContextMenuFileExtension } from './CdGetFileForPrintContextMenuFileExtension';
import { ChangeFileMenu } from './ChangeFileMenu';
import { CdCheckSignsContextMenuFileExtension } from './CdCheckSignsContextMenuFileExtension';
import { PkTCOfferContextMenuFileExtension } from './PkTCOfferContextMenuFileExtension';
import { ChAddContextMenuTemplates } from './ChAddContextMenuTemplates';
import { CdPrintApprovalListFileExtension } from './CdPrintApprovalListFileExtension';


ExtensionContainer.instance.registerExtension({extension: ChangeFileMenu, stage: ExtensionStage.AfterPlatform});
ExtensionContainer.instance.registerExtension({extension: CdSignFileContextMenuFileExtension, stage: ExtensionStage.AfterPlatform});
ExtensionContainer.instance.registerExtension({extension: CdGetFileForPrintContextMenuFileExtension, stage: ExtensionStage.AfterPlatform});
ExtensionContainer.instance.registerExtension({extension: CdCheckSignsContextMenuFileExtension, stage: ExtensionStage.AfterPlatform});
ExtensionContainer.instance.registerExtension({extension: PkTCOfferContextMenuFileExtension, stage: ExtensionStage.AfterPlatform});
ExtensionContainer.instance.registerExtension({extension: ChAddContextMenuTemplates, stage: ExtensionStage.AfterPlatform});
ExtensionContainer.instance.registerExtension({extension: CdPrintApprovalListFileExtension, stage: ExtensionStage.AfterPlatform});

        

